import UnlockEventCard from "../UnlockEventCard/UnlockEventCard";

interface UnlockEvent {
  dateTimestamp: number;
  percentOfCirculatingSupply: number;
  unlockAmount: number;
  unlockValue: number;
  rounds: {
    name: number;
    value: number;
  }[];
}

interface CountDownProgressProps {
  unlockEvents?: UnlockEvent[];
  tokenSymbol: string;
}

export const CountdownProgress = ({
  unlockEvents,
  tokenSymbol,
}: CountDownProgressProps) => {
  if (!unlockEvents || !unlockEvents.length) return null;

  return (
    <>
      {unlockEvents.map((unlockEvent, index) => (
        <UnlockEventCard
          key={index}
          unlockEvent={unlockEvent}
          tokenSymbol={tokenSymbol}
          index={index}
        />
      ))}
    </>
  );
};
